import React from 'react';

import Icon from 'Pods/Shared/Icon/Icon';
import CategoryCard from './CategoryCard';
import SoftwareCard from './SoftwareCard';

export default class TutorialFilterSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onSoftwareChange = this.onSoftwareChange.bind(this);
  }

  onCategoryChange(value, isChecked) {
    return this.props.onCategoryFilterChange(value, isChecked);
  }

  onSoftwareChange(value, isChecked) {
    return this.props.onSoftwareFilterChange(value, isChecked);
  }

  render() {
    const _this = this;

    const categoryNodes = this.props.categories.map((category) => {
      return (
        <CategoryCard
          key={category.id}
          selectedCategories={_this.props.selectedCategories}
          onCategoryCheckboxChange={_this.onCategoryChange}
          data={category}
        />
      );
    });

    const softwareNodes = this.props.software.map((software) => {
      return (
        <SoftwareCard
          key={software.id}
          selectedSoftware={_this.props.selectedSoftware}
          onSoftwareCheckboxChange={_this.onSoftwareChange}
          data={software}
        />
      );
    });

    return (
      <>
        <div
          className={
            this.props.isMobileFilterOpen
              ? 'tutorials-sidebar__content mobile-filters is-opened'
              : 'tutorials-sidebar__content mobile-filters'
          }
        >
          <div className="tutorials-sidebar__mobile-heading">
            <div className="tutorials-sidebar__back-button" onClick={this.props.onMobileFiltersClick}>
              <Icon type={['fas', 'chevron-left']} size="lg" />
            </div>
            <div className="tutorials-sidebar__header filter">
              <h5 className="section__title">Filter tutorials</h5>
            </div>
          </div>
          <div className="tutorials-sidebar__area">
            <div className="tutorials-sidebar__header">
              <h5 className="section__title">By Category</h5>
            </div>
            <div className="tutorials-sidebar__section card card--flat" id="categories-list">
              {categoryNodes}
            </div>
          </div>
          <div className="tutorials-sidebar__area">
            <div className="tutorials-sidebar__header">
              <h5 className="section__title">By Software</h5>
            </div>
            <div className="tutorials-sidebar__section card card--flat" id="software-list">
              {softwareNodes}
            </div>
          </div>
        </div>
      </>
    );
  }
}
